{
  "about.blocks": "Модерирани сервери",
  "about.contact": "Контакт:",
  "about.disclaimer": "Mastodon је бесплатан софтвер отвореног кода и заштићени знак компаније Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Разлог није наведен",
  "about.domain_blocks.preamble": "Mastodon вам генерално омогућава да видите садржај и комуницирате са корисницима са било ког другог сервера у федиверзуму. Ово су изузеци који су направљени на овом серверу.",
  "about.domain_blocks.silenced.explanation": "Нећете видети профиле и садржај са овог сервера осим ако их експлицитно не потражите или не запратите неки профил са сервера.",
  "about.domain_blocks.silenced.title": "Ограничен",
  "about.domain_blocks.suspended.explanation": "Подаци са овог сервера неће се обрађивати, чувати нити размењивати, што ће онемогућити било какву интеракцију или комуникацију са корисницима са овог сервера.",
  "about.domain_blocks.suspended.title": "Суспендован",
  "about.not_available": "Ове информације нису доступне на овом серверу.",
  "about.powered_by": "Децентрализована друштвена мрежа коју покреће {mastodon}",
  "about.rules": "Правила сервера",
  "account.add_or_remove_from_list": "Додај или уклони са листа",
  "account.badges.bot": "Аутоматизовано",
  "account.badges.group": "Група",
  "account.block": "Блокирај @{name}",
  "account.block_domain": "Блокирај домен {domain}",
  "account.block_short": "Блокирај",
  "account.blocked": "Блокиран",
  "account.cancel_follow_request": "Откажи праћење",
  "account.copy": "Копирај везу у профил",
  "account.direct": "Приватно помени @{name}",
  "account.disable_notifications": "Заустави обавештавање за објаве корисника @{name}",
  "account.edit_profile": "Уреди профил",
  "account.enable_notifications": "Обавести ме када @{name} објави",
  "account.endorse": "Истакни на профилу",
  "account.follow": "Прати",
  "account.follow_back": "Узврати праћење",
  "account.followers": "Пратиоци",
  "account.followers.empty": "Још увек нико не прати овог корисника.",
  "account.followers_counter": "{count, plural, one {{counter} пратилац} few {{counter} пратиоца} other {{counter} пратилаца}}",
  "account.following": "Прати",
  "account.following_counter": "{count, plural, one {{counter} прати} few {{counter} прати} other {{counter} прати}}",
  "account.follows.empty": "Овај корисник још увек никог не прати.",
  "account.go_to_profile": "Иди на профил",
  "account.hide_reblogs": "Сакриј подржавања од @{name}",
  "account.in_memoriam": "У знак сећања на.",
  "account.joined_short": "Датум придруживања",
  "account.languages": "Промени претплаћене језике",
  "account.link_verified_on": "Власништво над овом везом је проверено {date}",
  "account.locked_info": "Статус приватности овог налога је подешен на „закључано”. Власник ручно прегледа ко га може пратити.",
  "account.media": "Мултимедија",
  "account.mention": "Помени корисника @{name}",
  "account.moved_to": "Корисник {name} је назначио да је његов нови налог сада:",
  "account.mute": "Игнориши корисника @{name}",
  "account.mute_notifications_short": "Искључи обавештења",
  "account.mute_short": "Искључи",
  "account.muted": "Игнорисан",
  "account.no_bio": "Нема описа.",
  "account.open_original_page": "Отвори оригиналну страницу",
  "account.posts": "Објаве",
  "account.report": "Пријави @{name}",
  "account.requested_follow": "{name} је затражио да вас прати",
  "account.share": "Подели профил корисника @{name}",
  "account.show_reblogs": "Прикажи подржавања од корисника @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} објава} few {{counter} објаве} other {{counter} објава}}",
  "account.unblock": "Одблокирај корисника @{name}",
  "account.unblock_domain": "Одблокирај домен {domain}",
  "account.unblock_short": "Одблокирај",
  "account.unendorse": "Не истичи на профилу",
  "account.unfollow": "Отпрати",
  "account.unmute": "Не игнориши @{name}",
  "account.unmute_notifications_short": "Укључи обавештења",
  "account.unmute_short": "Не игнориши",
  "account_note.placeholder": "Кликните да додате напомену",
  "admin.dashboard.daily_retention": "Стопа задржавања корисника по данима након регистрације",
  "admin.dashboard.monthly_retention": "Стопа задржавања корисника по месецима након регистрације",
  "admin.dashboard.retention.average": "Просек",
  "admin.dashboard.retention.cohort": "Месец приступања",
  "admin.dashboard.retention.cohort_size": "Нови корисници",
  "admin.impact_report.instance_accounts": "Профили налога које би ово избрисало",
  "admin.impact_report.instance_followers": "Пратиоци које би наши корисници изгубили",
  "admin.impact_report.instance_follows": "Пратиоци које би њихови корисници изгубили",
  "admin.impact_report.title": "Резиме утицаја",
  "alert.rate_limited.message": "Покушајте поново после {retry_time, time, medium}.",
  "alert.rate_limited.title": "Ограничење захтева",
  "alert.unexpected.message": "Дошло је до неочекиване грешке.",
  "alert.unexpected.title": "Упс!",
  "announcement.announcement": "Најава",
  "attachments_list.unprocessed": "(необрађено)",
  "audio.hide": "Сакриј аудио",
  "block_modal.remote_users_caveat": "Замолићемо сервер {domain} да поштује вашу одлуку. Међутим, усклађеност није загарантована јер неки сервери могу другачије да обрађују блокове. Јавне објаве могу и даље бити видљиве корисницима који нису пријављени.",
  "block_modal.show_less": "Прикажи мање",
  "block_modal.show_more": "Прикажи више",
  "block_modal.they_will_know": "Могу да виде да су блокирани.",
  "block_modal.title": "Блокирати корисника?",
  "boost_modal.combo": "Можете притиснути {combo} да прескочите ово следећи пут",
  "bundle_column_error.copy_stacktrace": "Копирај извештај о грешци",
  "bundle_column_error.error.body": "Није могуће приказати тражену страницу. Разлог може бити грешка у нашем коду или проблем са компатибилношћу претраживача.",
  "bundle_column_error.error.title": "О, не!",
  "bundle_column_error.network.body": "Дошло је до грешке при покушају учитавања ове странице. Разлог може бити тренутни проблем са вашом интернет везом или са овим сервером.",
  "bundle_column_error.network.title": "Грешка на мрежи",
  "bundle_column_error.retry": "Покушајте поново",
  "bundle_column_error.return": "Иди на почетак",
  "bundle_column_error.routing.body": "Није могуће пронаћи тражену страницу. Да ли сте сигурни да је URL у адресном пољу исправан?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Затвори",
  "bundle_modal_error.retry": "Покушајте поново",
  "closed_registrations.other_server_instructions": "Пошто је Mastodon децентрализован, можете направити налог на другом серверу али и даље комуницирати са овим.",
  "closed_registrations_modal.description": "Креирање налога на {domain} тренутно није могуће, али имајте у виду да вам не треба налог засебно на {domain} да бисте користили Mastodon.",
  "closed_registrations_modal.find_another_server": "Пронађите други сервер",
  "closed_registrations_modal.preamble": "Mastodon је децентрализован, тако да без обзира где креирате свој налог, моћи ћете да пратите и комуницирате са било ким на овом серверу. Можете чак и сами да га хостујете!",
  "closed_registrations_modal.title": "Регистрација за Mastodon",
  "column.about": "Основни подаци",
  "column.blocks": "Блокирани корисници",
  "column.bookmarks": "Обележивачи",
  "column.community": "Локална временска линија",
  "column.direct": "Приватна помињања",
  "column.directory": "Прегледај профиле",
  "column.domain_blocks": "Блокирани домени",
  "column.favourites": "Омиљено",
  "column.firehose": "Извори уживо",
  "column.follow_requests": "Захтеви за праћење",
  "column.home": "Почетна",
  "column.lists": "Листе",
  "column.mutes": "Игнорисани корисници",
  "column.notifications": "Обавештења",
  "column.pins": "Закачене објаве",
  "column.public": "Здружена временска линија",
  "column_back_button.label": "Назад",
  "column_header.hide_settings": "Сакриј подешавања",
  "column_header.moveLeft_settings": "Премести колону улево",
  "column_header.moveRight_settings": "Премести колону удесно",
  "column_header.pin": "Закачи",
  "column_header.show_settings": "Прикажи подешавања",
  "column_header.unpin": "Откачи",
  "community.column_settings.local_only": "Само локално",
  "community.column_settings.media_only": "Само мултимедија",
  "community.column_settings.remote_only": "Само удаљено",
  "compose.language.change": "Промени језик",
  "compose.language.search": "Претрага језика...",
  "compose.published.body": "Објава објављена.",
  "compose.published.open": "Отвори",
  "compose.saved.body": "Објава је сачувана.",
  "compose_form.direct_message_warning_learn_more": "Сазнајте више",
  "compose_form.encryption_warning": "Објаве на Mastodon-у нису потпуно шифроване. Немојте делити никакве осетљиве информације преко Mastodon-а.",
  "compose_form.hashtag_warning": "Ова објава неће бити наведена ни под једном хеш ознаком јер није јавна. Само јавне објаве се могу претраживати по хеш ознакама.",
  "compose_form.lock_disclaimer": "Ваш налог није {locked}. Свако може да Вас запрати и да види објаве намењене само Вашим пратиоцима.",
  "compose_form.lock_disclaimer.lock": "закључан",
  "compose_form.placeholder": "О чему размишљате?",
  "compose_form.poll.duration": "Трајање анкете",
  "compose_form.poll.multiple": "Вишеструки избор",
  "compose_form.poll.option_placeholder": "Опција {number}",
  "compose_form.poll.switch_to_multiple": "Промените анкету да бисте омогућили више избора",
  "compose_form.poll.switch_to_single": "Промените анкету да бисте омогућили један избор",
  "compose_form.poll.type": "Стил",
  "compose_form.publish": "Објави",
  "compose_form.reply": "Одговори",
  "compose_form.save_changes": "Ажурирај",
  "compose_form.spoiler.marked": "Уклони упозорење о садржају",
  "compose_form.spoiler.unmarked": "Додај упозорење о садржају",
  "compose_form.spoiler_placeholder": "Упозорење о садржају (опционо)",
  "confirmation_modal.cancel": "Откажи",
  "confirmations.block.confirm": "Блокирај",
  "confirmations.delete.confirm": "Избриши",
  "confirmations.delete.message": "Да ли сте сигурни да желите да избришете ову објаву?",
  "confirmations.delete_list.confirm": "Избриши",
  "confirmations.delete_list.message": "Да ли сте сигурни да желите да трајно избришете ову листу?",
  "confirmations.discard_edit_media.confirm": "Одбаци",
  "confirmations.discard_edit_media.message": "Имате несачуване промене у опису или прегледу медија, да ли ипак хоћете да их одбаците?",
  "confirmations.logout.confirm": "Одјава",
  "confirmations.logout.message": "Да ли сте сигурни да желите да се одјавите?",
  "confirmations.mute.confirm": "Игнориши",
  "confirmations.redraft.confirm": "Избриши и преправи",
  "confirmations.redraft.message": "Да ли сте сигурни да желите да избришете ову објаву и да је преправите? Подржавања и ознаке као омиљених ће бити изгубљени, а одговори ће остати без оригиналне објаве.",
  "confirmations.unfollow.confirm": "Отпрати",
  "conversation.delete": "Избриши разговор",
  "conversation.mark_as_read": "Означи као прочитано",
  "conversation.open": "Прикажи разговор",
  "conversation.with": "Са {names}",
  "copy_icon_button.copied": "Копирано",
  "copypaste.copied": "Копирано",
  "copypaste.copy_to_clipboard": "Копирај",
  "directory.federated": "Са знаног федиверзума",
  "directory.local": "Само са {domain}",
  "directory.new_arrivals": "Новопридошли",
  "directory.recently_active": "Недавно активни",
  "disabled_account_banner.account_settings": "Подешавања налога",
  "disabled_account_banner.text": "Ваш налог {disabledAccount} је тренутно онемогућен.",
  "dismissable_banner.community_timeline": "Ово су најновије јавне објаве људи чије налоге хостује {domain}.",
  "dismissable_banner.dismiss": "Одбаци",
  "domain_block_modal.block": "Блокирај сервер",
  "domain_block_modal.block_account_instead": "Уместо тога, блокирај @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Људи са овог сервера могу да имају интеракцију са вашим старим објавама.",
  "domain_block_modal.they_cant_follow": "Нико са овог сервера не може да вас прати.",
  "domain_block_modal.they_wont_know": "Неће знати да су блокирани.",
  "domain_block_modal.title": "Блокирати домен?",
  "domain_block_modal.you_wont_see_posts": "Нећете видети објаве или обавештења корисника на овом серверу.",
  "domain_pill.activitypub_lets_connect": "Омогућује вам да се повежете и комуницирате са људима не само на Mastodon-у, већ и у различитим друштвеним апликацијама.",
  "domain_pill.activitypub_like_language": "ActivityPub је као језик којим Mastodon говори са другим друштвеним мрежама.",
  "domain_pill.server": "Сервер",
  "domain_pill.their_handle": "Његов регулатор:",
  "domain_pill.their_server": "Њихов дигитални дом, где живе све њихове објаве.",
  "domain_pill.their_username": "Њихов јединствени идентификатор на њиховом серверу. Могуће је пронаћи кориснике са истим корисничким именом на различитим серверима.",
  "domain_pill.username": "Корисничко име",
  "domain_pill.whats_in_a_handle": "Шта је регулатор?",
  "domain_pill.who_they_are": "Пошто регулатори говоре ко је неко и где се налази, можете да комуницирате са људима широм друштвеног веба на <button>платформама које покреће ActivityPub</button>.",
  "domain_pill.who_you_are": "Пошто ваши регулатори говори ко сте и где сте, људи могу да комуницирају са вама широм друштвеног веба на <button>платформама које покреће ActivityPub</button>.",
  "domain_pill.your_handle": "Ваш регулатор:",
  "domain_pill.your_server": "Ваш дигитални дом, где живе све ваше објаве. Не свиђа вам се овај? Пренесите сервере у било које време и доведите и своје пратиоце.",
  "domain_pill.your_username": "Њихов јединствени идентификатор на њиховом серверу. Могуће је пронаћи кориснике са истим корисничким именом на различитим серверима.",
  "embed.instructions": "Уградите ову објаву на свој веб сајт копирањем кода испод.",
  "embed.preview": "Ево како ће то изгледати:",
  "emoji_button.activity": "Активности",
  "emoji_button.clear": "Обриши",
  "emoji_button.custom": "Прилагођено",
  "emoji_button.flags": "Заставице",
  "emoji_button.food": "Храна и пиће",
  "emoji_button.label": "Убаци емоџи",
  "emoji_button.nature": "Природа",
  "emoji_button.not_found": "Нема пронађих одговарајућих емоџија",
  "emoji_button.objects": "Објекти",
  "emoji_button.people": "Људи",
  "emoji_button.recent": "Најчешће коришћени",
  "emoji_button.search": "Претрага...",
  "emoji_button.search_results": "Резултати претраге",
  "emoji_button.symbols": "Симболи",
  "emoji_button.travel": "Путовања и места",
  "empty_column.account_hides_collections": "Овај корисник је одлучио да ове информације не учини доступним",
  "empty_column.account_suspended": "Налог је суспендован",
  "empty_column.account_timeline": "Нема објава овде!",
  "empty_column.account_unavailable": "Профил је недоступан",
  "empty_column.blocks": "Још увек нисте блокирали ниједног корисника.",
  "empty_column.bookmarked_statuses": "Још увек немате објава доданих у обележиваче. Када додате неку, појавиће се овде.",
  "empty_column.community": "Локална временска линија је празна. Напишите нешто јавно да започнете!",
  "empty_column.direct": "Још увек немате приватних помињања. Када пошаљете или примите једно, оно ће се појавити овде.",
  "empty_column.domain_blocks": "Још увек нема блокираних домена.",
  "empty_column.explore_statuses": "Тренутно ништа није у тренду. Проверите поново касније!",
  "empty_column.favourited_statuses": "Још увек немате објава означених као омиљене. Када означите неку, појавиће се овде.",
  "empty_column.favourites": "Нико још није означио ову објаву као омиљену. Када неко то уради, појавиће се овде.",
  "empty_column.follow_requests": "Још увек немате ниједан захтев за праћење. Када примите захтев, он ће се појавити овде.",
  "empty_column.followed_tags": "Још увек нисте запратили ниједну хеш ознаку. Када то урадите, оне ће се појавити овде.",
  "empty_column.hashtag": "Још увек нема ничега у овој хеш ознаци.",
  "empty_column.home": "Ваша почетна временска линија је празна! Пратите више људи да бисте је попунили.",
  "empty_column.list": "У овој листи још нема ничега. Када чланови ове листе објаве нешто ново, појавиће се овде.",
  "empty_column.mutes": "Још увек не игноришете ниједног корисника.",
  "empty_column.notification_requests": "Све је чисто! Овде нема ничега. Када добијете нова обавештења, она ће се појавити овде у складу са вашим подешавањима.",
  "empty_column.notifications": "Још увек немате никаква обавештења. Када други људи буду у интеракцији са вама, видећете то овде.",
  "empty_column.public": "Овде нема ничега! Напишите нешто јавно или ручно пратите кориснике са других сервера да бисте ово попунили",
  "error.unexpected_crash.explanation": "Због грешке у нашем коду или проблема са компатибилношћу прегледача, ова страница се није могла правилно приказати.",
  "error.unexpected_crash.explanation_addons": "Ова страница се није могла правилно приказати. Ову грешку вероватно узрокују додаци прегледача или алати за аутоматско превођење.",
  "error.unexpected_crash.next_steps": "Покушајте да освежите страницу. Ако то не помогне, можда ћете и даље моћи да користите Mastodon путем другог прегледача или матичне апликације.",
  "error.unexpected_crash.next_steps_addons": "Покушајте да их онемогућите и освежите страницу. Ако то не помогне, можете да наставите да користите Mastodon коришћењем другог прегледача или матичне апликације.",
  "errors.unexpected_crash.copy_stacktrace": "Копирај „stacktrace” у клипборд",
  "errors.unexpected_crash.report_issue": "Пријави проблем",
  "explore.suggested_follows": "Људи",
  "explore.trending_links": "Вести",
  "explore.trending_statuses": "Објаве",
  "explore.trending_tags": "Хеш ознаке",
  "filter_modal.added.context_mismatch_explanation": "Ова категорија филтера се не односи на контекст у којем сте приступили овој објави. Ако желите да се објава филтрира и у овом контексту, морате уредити филтер.",
  "filter_modal.added.context_mismatch_title": "Контекст се не подудара!",
  "filter_modal.added.expired_explanation": "Ова категорија филтера је истекла, морате променити датум истека да би се примењивала.",
  "filter_modal.added.expired_title": "Филтер је истекао!",
  "filter_modal.added.review_and_configure": "За преглед и даљу конфигурацију ове категорије филтера, идите на {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Подешавања филтера",
  "filter_modal.added.settings_link": "страница подешавања",
  "filter_modal.added.short_explanation": "Ова објава је додата у следећу филтер категорију: {title}.",
  "filter_modal.added.title": "Филтер је додат!",
  "filter_modal.select_filter.context_mismatch": "не односи се на овај контекст",
  "filter_modal.select_filter.expired": "истекло",
  "filter_modal.select_filter.prompt_new": "Нова категорија: {name}",
  "filter_modal.select_filter.search": "Претражи или креирај",
  "filter_modal.select_filter.subtitle": "Користите постојећу категорију или креирајте нову",
  "filter_modal.select_filter.title": "Филтрирај ову објаву",
  "filter_modal.title.status": "Филтрирај објаву",
  "filtered_notifications_banner.title": "Филтрирана обавештења",
  "firehose.all": "Све",
  "firehose.local": "Овај сервер",
  "firehose.remote": "Остали сервери",
  "follow_request.authorize": "Одобри",
  "follow_request.reject": "Одбиј",
  "follow_requests.unlocked_explanation": "Иако ваш налог није закључан, особље {domain} сматра да бисте можда желели да ручно прегледате захтеве за праћење са ових налога.",
  "follow_suggestions.curated_suggestion": "Избор особља",
  "follow_suggestions.dismiss": "Не приказуј поново",
  "follow_suggestions.featured_longer": "Ручно одабрао тим {domain}",
  "follow_suggestions.friends_of_friends_longer": "Популарно међу људима које пратите",
  "follow_suggestions.hints.featured": "Овај профил је ручно изабрао тим {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Овај профил је популаран међу људима које пратите.",
  "follow_suggestions.hints.most_followed": "Овај профил је један од најпраћенијих на {domain}.",
  "follow_suggestions.hints.most_interactions": "Овај профил је недавно добио велику пажњу на {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Овај профил је сличан профилима које сте недавно запратили.",
  "follow_suggestions.personalized_suggestion": "Персонализовани предлог",
  "follow_suggestions.popular_suggestion": "Популарни предлог",
  "follow_suggestions.popular_suggestion_longer": "Популарно на {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Слично профилима које сте недавно запратили",
  "follow_suggestions.view_all": "Прикажи све",
  "follow_suggestions.who_to_follow": "Кога пратити",
  "followed_tags": "Праћене хеш ознаке",
  "footer.about": "Основни подаци",
  "footer.directory": "Директоријум профила",
  "footer.get_app": "Преузмите апликацију",
  "footer.keyboard_shortcuts": "Тастерске пречице",
  "footer.privacy_policy": "Политика приватности",
  "footer.source_code": "Прикажи изворни код",
  "footer.status": "Статус",
  "generic.saved": "Сачувано",
  "getting_started.heading": "Први кораци",
  "hashtag.column_header.tag_mode.all": "и {additional}",
  "hashtag.column_header.tag_mode.any": "или {additional}",
  "hashtag.column_header.tag_mode.none": "без {additional}",
  "hashtag.column_settings.select.no_options_message": "Нису пронађени предлози",
  "hashtag.column_settings.select.placeholder": "Унесите хеш ознаке…",
  "hashtag.column_settings.tag_mode.all": "Све",
  "hashtag.column_settings.tag_mode.any": "Било које од ових",
  "hashtag.column_settings.tag_mode.none": "Ниједан од ових",
  "hashtag.column_settings.tag_toggle": "Укључи додатне ознаке за ову колону",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} учесник} few {{counter} учесника} other {{counter} учесника}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} објава} few {{counter} објаве} other {{counter} објава}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} објава} few {{counter} објаве} other {{counter} објава}} данас",
  "hashtag.follow": "Запрати хеш ознаку",
  "hashtag.unfollow": "Отпрати хеш ознаку",
  "hashtags.and_other": "…и {count, plural, one {још #} few {још #}other {још #}}",
  "home.column_settings.show_reblogs": "Прикажи подржавања",
  "home.column_settings.show_replies": "Прикажи одговоре",
  "home.hide_announcements": "Сакриј најаве",
  "home.pending_critical_update.body": "Ажурирајте свој Mastodon сервер што је пре могуће!",
  "home.pending_critical_update.link": "Погледајте ажурирања",
  "home.pending_critical_update.title": "Доступно је критично безбедносно ажурирање!",
  "home.show_announcements": "Пријажи најаве",
  "interaction_modal.on_another_server": "На другом серверу",
  "interaction_modal.on_this_server": "На овом серверу",
  "intervals.full.days": "{number, plural, one {# дан} few {# дана} other {# дана}}",
  "intervals.full.hours": "{number, plural, one {# сат} few {# сата} other {# сати}}",
  "intervals.full.minutes": "{number, plural, one {# минут} few {# минута} other {# минута}}",
  "keyboard_shortcuts.back": "Иди назад",
  "keyboard_shortcuts.blocked": "Отвори листу блокираних корисника",
  "keyboard_shortcuts.boost": "Подржи објаву",
  "keyboard_shortcuts.column": "Фокусирај колону",
  "keyboard_shortcuts.compose": "Фокусирај поље за састављање објаве",
  "keyboard_shortcuts.description": "Опис",
  "keyboard_shortcuts.down": "Премести надоле у листи",
  "keyboard_shortcuts.enter": "Отвори објаву",
  "keyboard_shortcuts.favourite": "Означи објаву као омиљену",
  "keyboard_shortcuts.favourites": "Отвори листу омиљених",
  "keyboard_shortcuts.federated": "Отвори здружену временску линију",
  "keyboard_shortcuts.heading": "Тастерске пречице",
  "keyboard_shortcuts.home": "Отвори почетну временску линију",
  "keyboard_shortcuts.hotkey": "Пречица",
  "keyboard_shortcuts.legend": "Прикажи ову легенду",
  "keyboard_shortcuts.local": "Отвори локалну временску линију",
  "keyboard_shortcuts.mention": "Помени аутора",
  "keyboard_shortcuts.muted": "Отвори листу игнорисаних корисника",
  "keyboard_shortcuts.my_profile": "Отворите свој профил",
  "keyboard_shortcuts.notifications": "Отвори колону обавештења",
  "keyboard_shortcuts.open_media": "Отвори мултимедију",
  "keyboard_shortcuts.pinned": "Отвори листу закачених објава",
  "keyboard_shortcuts.profile": "Отвори профил аутора",
  "keyboard_shortcuts.reply": "Одговори на објаву",
  "keyboard_shortcuts.requests": "Отвори листу захтева за праћење",
  "keyboard_shortcuts.search": "Фокусирај траку претраге",
  "keyboard_shortcuts.spoilers": "Прикажи/сакриј поље текста упозорења о садржају (CW)",
  "keyboard_shortcuts.start": "Отвори колону „први кораци”",
  "keyboard_shortcuts.toggle_hidden": "Прикажи/сакриј текст иза упозорења",
  "keyboard_shortcuts.toggle_sensitivity": "Прикажи/сакриј мултимедију",
  "keyboard_shortcuts.toot": "Започни нову објаву",
  "keyboard_shortcuts.unfocus": "Уклони фокус са поља за унос текста/претраге",
  "keyboard_shortcuts.up": "Премести нагоре у листи",
  "lightbox.close": "Затвори",
  "lightbox.next": "Следеће",
  "lightbox.previous": "Претходно",
  "limited_account_hint.action": "Ипак прикажи профил",
  "limited_account_hint.title": "Овај профил су сакрили модератори {domain}.",
  "link_preview.author": "По {name}",
  "link_preview.more_from_author": "Више од {name}",
  "link_preview.shares": "{count, plural, one {{counter} објава} few {{counter} објаве} other {{counter} објава}}",
  "lists.delete": "Избриши листу",
  "lists.edit": "Уреди листу",
  "lists.replies_policy.followed": "Сваком праћеном кориснику",
  "lists.replies_policy.list": "Члановима листе",
  "lists.replies_policy.none": "Никоме",
  "load_pending": "{count, plural, one {# нова ставка} few {# нове ставке} other {# нових ставки}}",
  "loading_indicator.label": "Учитавање…",
  "moved_to_account_banner.text": "Ваш налог {disabledAccount} је тренутно онемогућен јер сте прешли на {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Сакриј из обавештења",
  "mute_modal.hide_options": "Сакриј опције",
  "mute_modal.indefinite": "Док их не уклоним из игнорисаних",
  "mute_modal.show_options": "Прикажи опције",
  "mute_modal.they_can_mention_and_follow": "Могу да вас помињу и прате, али их нећете видети.",
  "mute_modal.they_wont_know": "Неће знати да су игнорисани.",
  "mute_modal.title": "Игнорисати корисника?",
  "mute_modal.you_wont_see_mentions": "Нећете видети објаве које га помињу.",
  "mute_modal.you_wont_see_posts": "И даље може да види ваше објаве, али ви нећете видети његове.",
  "navigation_bar.about": "Основни подаци",
  "navigation_bar.advanced_interface": "Отвори у напредном веб окружењу",
  "navigation_bar.blocks": "Блокирани корисници",
  "navigation_bar.bookmarks": "Обележивачи",
  "navigation_bar.direct": "Приватна помињања",
  "navigation_bar.domain_blocks": "Блокирани домени",
  "navigation_bar.favourites": "Омиљено",
  "navigation_bar.filters": "Игнорисане речи",
  "navigation_bar.follow_requests": "Захтеви за праћење",
  "navigation_bar.followed_tags": "Праћене хеш ознаке",
  "navigation_bar.follows_and_followers": "Праћења и пратиоци",
  "navigation_bar.lists": "Листе",
  "navigation_bar.logout": "Одјава",
  "navigation_bar.mutes": "Игнорисани корисници",
  "navigation_bar.opened_in_classic_interface": "Објаве, налози и друге специфичне странице се подразумевано отварају у класичном веб окружењу.",
  "navigation_bar.preferences": "Подешавања",
  "navigation_bar.search": "Претрага",
  "not_signed_in_indicator.not_signed_in": "Морате да се пријавите да бисте приступили овом ресурсу.",
  "notification.admin.report": "{name} је пријавио/-ла {target}",
  "notification.admin.sign_up": "{name} се регистровао/-ла",
  "notification.favourite": "{name} је означио вашу објаву као омиљену",
  "notification.follow": "{name} вас је запратио",
  "notification.follow_request": "{name} је затражио да вас прати",
  "notification.moderation-warning.learn_more": "Сазнајте више",
  "notification.moderation_warning": "Добили сте модераторско упозорење",
  "notification.moderation_warning.action_delete_statuses": "Неке од ваших објава су уклоњене.",
  "notification.moderation_warning.action_disable": "Ваш налог је онемогућен.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Неке од ваших објава су обележене као осетљиве.",
  "notification.moderation_warning.action_none": "Ваш налог је добио модераторско упозорење.",
  "notification.moderation_warning.action_sensitive": "Ваше објаве ће убудуће бити означене као осетљиве.",
  "notification.moderation_warning.action_silence": "Ваш налог је ограничен.",
  "notification.moderation_warning.action_suspend": "Ваш налог је суспендован.",
  "notification.own_poll": "Ваша анкета је завршена",
  "notification.reblog": "{name} је подржао вашу објаву",
  "notification.relationships_severance_event": "Изгубљена веза са {name}",
  "notification.relationships_severance_event.account_suspension": "Администратор са {from} је суспендовао {target}, што значи да више не можете да примате ажурирања од њих нити да комуницирате са њима.",
  "notification.relationships_severance_event.domain_block": "Администратор са {from} је блокирао {target}, укључујући ваше пратиоце: {followersCount} и {followingCount, plural, one {# налог} few {# налогa} other {# налога}} које пратите.",
  "notification.relationships_severance_event.learn_more": "Сазнајте више",
  "notification.relationships_severance_event.user_domain_block": "Блокирачи сте {target}, укључујући ваше пратиоце: {followersCount} и {followingCount, plural, one {# налог} few {# налогa} other {# налога}} које пратите.",
  "notification.status": "{name} је управо објавио",
  "notification.update": "{name} је уредио објаву",
  "notification_requests.accept": "Прихвати",
  "notification_requests.dismiss": "Одбаци",
  "notification_requests.notifications_from": "Обавештења од {name}",
  "notification_requests.title": "Филтрирана обавештења",
  "notifications.clear": "Обриши обавештења",
  "notifications.clear_confirmation": "Да ли сте сигурни да желите трајно да обришете сва ваша обавештења?",
  "notifications.column_settings.admin.report": "Нове пријаве:",
  "notifications.column_settings.admin.sign_up": "Нове рагистрације:",
  "notifications.column_settings.alert": "Обавештења на радној површини",
  "notifications.column_settings.favourite": "Омиљено:",
  "notifications.column_settings.filter_bar.advanced": "Прикажи све категорије",
  "notifications.column_settings.filter_bar.category": "Трака за брзо филтрирање",
  "notifications.column_settings.follow": "Нови пратиоци:",
  "notifications.column_settings.follow_request": "Нови захтеви за праћење:",
  "notifications.column_settings.mention": "Помињања:",
  "notifications.column_settings.poll": "Резултати анкете:",
  "notifications.column_settings.push": "Прослеђена обавештења",
  "notifications.column_settings.reblog": "Подржавања:",
  "notifications.column_settings.show": "Прикажи у колони",
  "notifications.column_settings.sound": "Репродукуј звук",
  "notifications.column_settings.status": "Нове објаве:",
  "notifications.column_settings.unread_notifications.category": "Непрочитана обавештења",
  "notifications.column_settings.unread_notifications.highlight": "Истакни непрочитана обавештења",
  "notifications.column_settings.update": "Уређивања:",
  "notifications.filter.all": "Све",
  "notifications.filter.boosts": "Подржавања",
  "notifications.filter.favourites": "Омиљено",
  "notifications.filter.follows": "Праћења",
  "notifications.filter.mentions": "Помињања",
  "notifications.filter.polls": "Резултати анкете",
  "notifications.filter.statuses": "Ажурирања од људи које пратите",
  "notifications.grant_permission": "Одобри дозволу.",
  "notifications.group": "{count} обавештења",
  "notifications.mark_as_read": "Означи свако обавештење као прочитано",
  "notifications.permission_denied": "Обавештења на радној површини нису доступна због претходно одбијеног захтева за дозволу прегледача",
  "notifications.permission_denied_alert": "Обавештења на радној површини не могу бити омогућена, јер је дозвола прегледача раније била одбијена",
  "notifications.permission_required": "Обавештења на радној површини нису доступна јер потребна дозвола није додељена.",
  "notifications.policy.filter_new_accounts.hint": "Креирано {days, plural, one {у последњег # дана} few {у последња # дана} other {у последњих # дана}}",
  "notifications.policy.filter_new_accounts_title": "Нови налози",
  "notifications.policy.filter_not_followers_hint": "Укључујући људе који су вас пратили мање од {days, plural, one {# дана} few {# дана} other {# дана}}",
  "notifications.policy.filter_not_followers_title": "Људи који вас не прате",
  "notifications.policy.filter_not_following_hint": "Док их ручно не одобрите",
  "notifications.policy.filter_not_following_title": "Људи које не пратите",
  "notifications.policy.filter_private_mentions_hint": "Филтрирано осим ако је одговор на ваше помињање или ако пратите пошиљаоца",
  "notifications.policy.filter_private_mentions_title": "Нежељена приватна помињања",
  "notifications_permission_banner.enable": "Омогућити обавештења на радној површини",
  "notifications_permission_banner.how_to_control": "Да бисте примали обавештења када Mastodon није отворен, омогућите обавештења на радној површини. Kада су обавештења на радној површини омогућена врсте интеракција које она генеришу могу се подешавати помоћу дугмета {icon}.",
  "notifications_permission_banner.title": "Никада ништа не пропустите",
  "onboarding.follows.empty": "Нажалост, тренутно се не могу приказати резултати. Можете покушати са коришћењем претраге или прегледањем странице за истраживање да бисте пронашли људе које ћете пратити или покушајте поново касније.",
  "onboarding.profile.discoverable": "Нека се мој профил може открити другима",
  "onboarding.profile.discoverable_hint": "Када омогућите могућност откривања на Mastodon-у, ваше објаве се могу појавити у резултатима претраге и у тренду, а ваш профил може бити предложен људима са сличним интересовањима.",
  "onboarding.profile.display_name": "Име за приказ",
  "onboarding.profile.display_name_hint": "Ваше пуно име или надимак…",
  "onboarding.profile.note": "Биографија",
  "onboarding.profile.note_hint": "Можете да @поменете друге људе или #хеш ознаке…",
  "onboarding.profile.title": "Подешавање профила",
  "onboarding.profile.upload_avatar": "Отпреми слику профила",
  "onboarding.profile.upload_header": "Отпреми заглавље профила",
  "password_confirmation.exceeds_maxlength": "Потврда лозинке премашује максималну дужину лозинке",
  "password_confirmation.mismatching": "Потврда лозинке се не подудара",
  "picture_in_picture.restore": "Врати назад",
  "poll.closed": "Затворено",
  "poll.refresh": "Освежи",
  "poll.reveal": "Види резултате",
  "poll.total_people": "{count, plural, one {# особа} few {# особе} other {# особа}}",
  "poll.total_votes": "{count, plural, one {# глас} few {# гласа} other {# гласова}}",
  "poll.vote": "Гласајте",
  "poll.voted": "Гласали сте за овај одговор",
  "poll.votes": "{votes, plural, one {# глас} few {# гласа} other {# гласова}}",
  "poll_button.add_poll": "Додај анкету",
  "poll_button.remove_poll": "Уклони анкету",
  "privacy.change": "Промени приватност објаве",
  "privacy.direct.long": "Сви поменути у објави",
  "privacy.private.long": "Само ваши пратиоци",
  "privacy.private.short": "Пратиоци",
  "privacy.public.long": "Било ко на Mastodon-у и ван њега",
  "privacy.public.short": "Јавно",
  "privacy.unlisted.additional": "Ово се понаша потпуно као јавно, осим што се објава неће појављивати у изворима уживо или хеш ознакама, истраживањима или претрази Mastodon-а, чак и ако сте укључени у целом налогу.",
  "privacy.unlisted.short": "Тиха јавност",
  "privacy_policy.last_updated": "Последње ажурирање {date}",
  "privacy_policy.title": "Политика приватности",
  "recommended": "Препоручено",
  "refresh": "Освежи",
  "relative_time.days": "{number} дан.",
  "relative_time.full.days": "Пре {number, plural, one {# дан} few {# дана} other {# дана}}",
  "relative_time.full.hours": "пре {number, plural, one {# сат} few {# сата} other {# сати}}",
  "relative_time.full.just_now": "управо сад",
  "relative_time.full.minutes": "пре {number, plural, one {# минут} few {# минута} other {# минута}}",
  "relative_time.full.seconds": "пре {number, plural, one {# секунду} few {# секунде} other {# секунди}}",
  "relative_time.hours": "{number} час.",
  "relative_time.just_now": "сада",
  "relative_time.minutes": "{number} мин.",
  "relative_time.seconds": "{number} сек.",
  "relative_time.today": "данас",
  "reply_indicator.attachments": "{count, plural, one {# прилог} few {# прилога} other {# прилога}}",
  "reply_indicator.cancel": "Откажи",
  "reply_indicator.poll": "Анкета",
  "report.block": "Блокирај",
  "report.block_explanation": "Нећете видети објаве корисника. Ни он неће видети Ваше објаве нити ће моћи да Вас прати. Такође ће моћи да сазна да је блокиран.",
  "report.categories.legal": "Правни",
  "report.categories.other": "Остало",
  "report.categories.spam": "Спам",
  "report.categories.violation": "Садржај крши једно или више правила сервера",
  "report.category.subtitle": "Одаберите најприближније",
  "report.category.title": "Реците нам шта је проблем са {type}",
  "report.category.title_account": "овим профилом",
  "report.category.title_status": "објавом",
  "report.close": "Готово",
  "report.comment.title": "Да ли има још нешто што бисте хтели да нам дате до знања?",
  "report.forward": "Проследити {target}",
  "report.forward_hint": "Налог је са другог сервера. Послати анонимну копију пријаве и тамо?",
  "report.mute": "Игнориши",
  "report.mute_explanation": "Нећете видети објаве корисника. Он ће и даље моћи да Вас прати и види Ваше објаве и неће знати да је игнорисан.",
  "report.next": "Следеће",
  "report.placeholder": "Додатни коментари",
  "report.reasons.dislike": "Не свиђа ми се",
  "report.reasons.dislike_description": "Ово није нешто што желите да видите",
  "report.reasons.legal": "То је противзаконито",
  "report.reasons.legal_description": "Сматрате да то крши закон ваше или земље сервера",
  "report.reasons.other": "Нешто друго",
  "report.reasons.other_description": "Проблем се не уклапа у друге категорије",
  "report.reasons.spam": "Ово је спам",
  "report.reasons.spam_description": "Злонамерне везе, лажно ангажовање или одговори који се понављају",
  "report.reasons.violation": "Крши правила сервера",
  "report.reasons.violation_description": "Свесни сте да крши одређена правила",
  "report.rules.subtitle": "Изаберите сва правила која су прекршена",
  "report.rules.title": "Која правила су прекршена?",
  "report.statuses.subtitle": "Изаберите све што важи",
  "report.statuses.title": "Има ли било каквих објава које поткрепљују ову пријаву?",
  "report.submit": "Пошаљи",
  "report.target": "Пријављујем {target}",
  "report.thanks.take_action": "Ово су Ваше опције да контролишете шта видите на Mastodon-у:",
  "report.thanks.take_action_actionable": "Док ми прегледамо ово, можете применити следеће радње против @{name}:",
  "report.thanks.title": "Не желите да видите ово?",
  "report.thanks.title_actionable": "Хвала на пријави, прегледаћемо је.",
  "report.unfollow": "Отпрати @{name}",
  "report.unfollow_explanation": "Пратите овај налог. Да не бисте више видели његове објаве на почетној страници, отпратите га.",
  "report_notification.attached_statuses": "{count, plural, one {{count} објава} few {{count} објаве} other {{count} објава}} у прилогу",
  "report_notification.categories.legal": "Легално",
  "report_notification.categories.other": "Остало",
  "report_notification.categories.spam": "Спам",
  "report_notification.categories.violation": "Кршење правила",
  "report_notification.open": "Отвори пријаву",
  "search.no_recent_searches": "Нема недавних претрага",
  "search.placeholder": "Претрага",
  "search.quick_action.account_search": "Подударање профила {x}",
  "search.quick_action.go_to_account": "Иди на профил {x}",
  "search.quick_action.go_to_hashtag": "Иди на хеш ознаку {x}",
  "search.quick_action.open_url": "Отвори URL адресу у Mastodon-у",
  "search.quick_action.status_search": "Подударање објава {x}",
  "search.search_or_paste": "Претражите или унесите адресу",
  "search_popout.full_text_search_disabled_message": "Није доступно на {domain}.",
  "search_popout.full_text_search_logged_out_message": "Доступно само када сте пријављени.",
  "search_popout.language_code": "ISO код језика",
  "search_popout.options": "Опције претраге",
  "search_popout.quick_actions": "Брзе радње",
  "search_popout.recent": "Недавне претраге",
  "search_popout.specific_date": "одређени датум",
  "search_popout.user": "корисник",
  "search_results.accounts": "Профили",
  "search_results.all": "Све",
  "search_results.hashtags": "Хеш ознаке",
  "search_results.see_all": "Види све",
  "search_results.statuses": "Објаве",
  "server_banner.about_active_users": "Људи који су користили овај сервер у претходних 30 дана (месечно активних корисника)",
  "server_banner.active_users": "активних корисника",
  "server_banner.administered_by": "Администрира:",
  "server_banner.is_one_of_many": "{domain} је један од многих независних Mastodon сервера које можете користити за учешће у федиверзуму.",
  "server_banner.server_stats": "Статистике сервера:",
  "sign_in_banner.create_account": "Направите налог",
  "sign_in_banner.follow_anyone": "Пратите било кога широм федиверзума и погледајте све хронолошким редом. Нема алгоритама, реклама или мамаца за кликове на видику.",
  "sign_in_banner.mastodon_is": "Mastodon је најбољи начин да будете у току са оним што се дешава.",
  "sign_in_banner.sign_in": "Пријавите се",
  "sign_in_banner.sso_redirect": "Пријавите се или се региструјте",
  "status.admin_account": "Отвори модераторско окружење за @{name}",
  "status.admin_domain": "Отвори модераторско окружење за {domain}",
  "status.admin_status": "Отвори ову објаву у модераторском окружењу",
  "status.block": "Блокирај @{name}",
  "status.bookmark": "Додај у обележиваче",
  "status.cancel_reblog_private": "Уклони подршку",
  "status.cannot_reblog": "Ова објава се не може подржати",
  "status.copy": "Копирај везу у објаву",
  "status.delete": "Избриши",
  "status.detailed_status": "Детаљан приказ разговора",
  "status.direct": "Приватно помени @{name}",
  "status.direct_indicator": "Приватно помињање",
  "status.edit": "Уреди",
  "status.edited": "Последње уређивање {date}",
  "status.edited_x_times": "Уређено {count, plural, one {{count} пут} other {{count} пута}}",
  "status.favourite": "Омиљено",
  "status.filter": "Филтрирај ову објаву",
  "status.history.created": "{name} написао/ла {date}",
  "status.history.edited": "{name} уредио/ла {date}",
  "status.load_more": "Учитај још",
  "status.media.open": "Кликните за отварање",
  "status.media.show": "Кликните за приказ",
  "status.media_hidden": "Мултимедија сакривена",
  "status.mention": "Помени @{name}",
  "status.more": "Још",
  "status.mute": "Игнориши @{name}",
  "status.mute_conversation": "Игнориши разговор",
  "status.open": "Прошири ову објаву",
  "status.pin": "Закачи на профил",
  "status.read_more": "Прочитајте више",
  "status.reblog": "Подржи",
  "status.reblogged_by": "{name} је подржао/ла",
  "status.reblogs.empty": "Још увек нико није подржао ову објаву. Када буде подржана, појавиће се овде.",
  "status.redraft": "Избриши и преобликуј",
  "status.remove_bookmark": "Уклони обележивач",
  "status.replied_to": "Одговор за {name}",
  "status.reply": "Одговори",
  "status.replyAll": "Одговори на низ",
  "status.report": "Пријави @{name}",
  "status.sensitive_warning": "Осетљив садржај",
  "status.share": "Подели",
  "status.show_less_all": "Прикажи мање за све",
  "status.show_more_all": "Прикажи више за све",
  "status.show_original": "Прикажи оргинал",
  "status.title.with_attachments": "{user} је објавио {attachmentCount, plural, one {прилог} few {{attachmentCount} прилога} other {{attachmentCount} прилога}}",
  "status.translate": "Преведи",
  "status.translated_from_with": "Преведено са {lang} користећи {provider}",
  "status.uncached_media_warning": "Преглед није доступан",
  "status.unmute_conversation": "Не игнориши разговор",
  "status.unpin": "Откачи са профила",
  "subscribed_languages.lead": "Само објаве на означеним језицима ће се појављивати на почетној линији и на листама после ове измене. Када ниједан језик није изабран, примаћете објаве на свим језицима.",
  "subscribed_languages.save": "Сачувај измене",
  "subscribed_languages.target": "Промени језике на које је {target} пријављен",
  "tabs_bar.home": "Почетна",
  "tabs_bar.notifications": "Обавештења",
  "time_remaining.days": "Остало {number, plural, one {# дан} few {# дана} other {# дана}}",
  "time_remaining.hours": "Остало {number, plural, one {# сат} few {# сата} other {# сати}}",
  "time_remaining.minutes": "Остало {number, plural, one {# минут} few {# минута} other {# минута}}",
  "time_remaining.moments": "Још неколико тренутака",
  "time_remaining.seconds": "Остало {number, plural, one {# секунд} few {# секунде} other {# секунди}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} особа} few {{counter} особе} other {{counter} особа}} у протеклих {days, plural, one {дан} other {{days} дана}}",
  "trends.trending_now": "У тренду сада",
  "ui.beforeunload": "Ваш нацрт ће бити изгубљен ако напустите Mastodon.",
  "units.short.billion": "{count} млрд.",
  "units.short.million": "{count} мил.",
  "units.short.thousand": "{count} хиљ.",
  "upload_area.title": "Превуците и отпустите за отпремање",
  "upload_button.label": "Додај слике, видео или аудио датотеку",
  "upload_error.limit": "Достигнуто је ограничење за отпремање датотека.",
  "upload_error.poll": "Отпремање датотека није дозвољено код анкета.",
  "upload_form.edit": "Уреди",
  "upload_progress.label": "Отпремање...",
  "upload_progress.processing": "Обрада…",
  "username.taken": "То корисничко име је заузето. Покушајте друго",
  "video.close": "Затвори видео",
  "video.download": "Преузимање датотеке",
  "video.exit_fullscreen": "Изађи из режима целог екрана",
  "video.expand": "Прошири видео",
  "video.fullscreen": "Цео екран",
  "video.hide": "Сакриј видео",
  "video.pause": "Паузирај",
  "video.play": "Репродукуј"
}
